export const environment = {
  production: true,
  domain: 'skillschecker.mt/mt',
  api: {
    host: 'https://www.skillschecker.mt',
    // host: 'http://skillschecker.mt',
    port: '',
    path: '/api/',
  },
  readspeaker: {
    enabled: false,
    id: 12420,
    lang: 'en_uk',
    voice: 'Hugh',
    baseurl: '//app-eu.readspeaker.com/cgi-bin/rsent'
  },
  analytics: {
    google: {
      id: 'UA-170127374-2'
    }
  },
  download: {
    level: true
  },
  product: 'nala-mt2',
  locale: 'mt',
  regions: [
    'Online',
    'Malta',
    'Għawdex'
  ],
  regions_orig: [
    'Online',
    'Birkirkara',
    'Blata l-Bajda Adult Learning Centre',
    'Floriana',
    'Għajnsielem (Gozo)',
    'Ħal Far',
    'Mosta',
    'Paola',
    'Qormi',
    'Qormi Local Council',
    'Tarxien Adult Learning Centre',
    'Valletta',
    'Żebbuġ'
  ]
};
